import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minutesHumanise'
})
export class MinutesHumanisePipe implements PipeTransform {

  transform(value: number): string {
    if (!value || value < 0) return '0 min';

    const days = Math.floor(value / (24 * 60));
    const hours = Math.floor((value % (24 * 60)) / 60);
    const minutes = value % 60;

    const parts: string[] = [];

    if (days > 0) {
      parts.push(`${days} jour${days > 1 ? 's' : ''}`);
    }

    if (hours > 0) {
      parts.push(`${hours} heure${hours > 1 ? 's' : ''}`);
    }

    if (minutes > 0 || parts.length === 0) {
      parts.push(`${minutes} min`);
    }

    return parts.join(' ');
  }

}
